import { render, staticRenderFns } from "./architecture-driver.vue?vue&type=template&id=70a90a9c&scoped=true"
import script from "./architecture-driver.vue?vue&type=script&lang=js"
export * from "./architecture-driver.vue?vue&type=script&lang=js"
import style0 from "./architecture-driver.vue?vue&type=style&index=0&id=70a90a9c&prod&lang=scss&scoped=true"
import style1 from "./architecture-driver.vue?vue&type=style&index=1&id=70a90a9c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a90a9c",
  null
  
)

export default component.exports